export default "__VITE_ASSET__BNyW6IaZ__"